/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { Button, Dropdown, Menu } from 'antd';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../assets/Images/icons/icon-back';
import { DownloadOutlined } from '@ant-design/icons';
import useQuery from '../../util/useQuery';
import RiskAssessmentDetailView from './RiskAssessmentDetailView';
import RiskAssessmentService from '../../services/RiskAssessment.service';
import UserService from '../../services/UserService';
import ModalConfirm from '../../components/Shared/modal/confirm';
import ModalSuccess from '../../components/Shared/modal/success';
import ModalFail from '../../components/Shared/modal/fail';
import moment from 'moment';
import { ROUTER } from '../../constants/router';
import RiskRegisterService from '../../services/RiskRegister.service';
import usePermission from '../../hooks/usePermission';

export const RiskAssessmentView = () => {
    const { view } = useParams();
    const { riskId } = useParams();
    const { t } = useTranslation();
    let navigate = useNavigate();
    const params = useQuery();
    const [visible] = useState(false);
    const [riskAssessmentData, setRiskAssessmentData] = useState();
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openFail, setOpenFail] = useState(false);

    //history
    const [histories, setHistories] = useState([]);

    const [page, setPage] = useState(1);

    const { isAuditor } = usePermission();
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    useEffect(() => {
        if (visible) {
            getHistory();
        } else {
            setHistories([]);
            setPage(1);
        }
    }, [visible]);

    const getHistory = async () => {
        const params = {
            riskAssessmentId: riskId,
            p: page,
            ps: 10,
            sd: 'DESC',
        };

        try {
            setTimeout(async () => {
                const { data } = await RiskAssessmentService.getHistories(
                    params
                );
                if (data?.resultData) {
                    const history = histories.concat(data.resultData?.result);
                    setHistories(history);
                    setPage(page + 1);
                }
            }, 1000);
        } catch (error) {
            console.log(error);
        }
    };

    const switchText = () => {
        const tab = params.get('tab');
        if (tab === '2') {
            return t('Risk Map');
        } else if (tab === '3') {
            return t('Likelihood');
        } else {
            return t('Type Risk Factor');
        }
    };

    const getRiskRegisterHeader = async () => {
        try {
            const { data } = await RiskRegisterService.getRiskRegisterHeader();
            if (data?.resultData) {
                const item = data?.resultData[0];
                setRiskAssessmentData(item);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getRiskRegisterHeader();
    }, []);

    const exportRiskAssessment = async (id, isPublic) => {
        try {
            const res = await RiskAssessmentService.exportRiskAssessment({
                riskAssessmenntId: id,
                isPublicVersion: isPublic,
            });
            const objectURL = window.URL.createObjectURL(new Blob([res?.data]));
            const link = document.createElement('a');
            link.href = objectURL;
            link.download = `riskAssessment_report_export${moment(
                new Date()
            ).format('_DDMMYYYYhhmmss')}.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            setOpenFail(true);
            console.log(error);
        }
    };

    const publicRiskAssessment = async (id) => {
        try {
            const { data } = await RiskAssessmentService.publicRiskAssessment({
                riskAssessmentId: id,
            });
            if (data?.resultMsg === 'FAILURE') {
                setOpenFail(true);
            } else {
                getRiskRegisterHeader();
                setOpenSuccess(true);
            }
        } catch (error) {
            setOpenFail(true);
            console.log(error);
        }
    };

    const menu = (
        <Menu style={{ borderRadius: '6px' }}>
            <Menu.ItemGroup
                className="p-2"
                style={{ borderBottom: '1px solid #ECECEC' }}
                title={t('RA.SelectExport')}
            />
            <Menu.Item
                className={`p-4 ${
                    riskAssessmentData?.version.split('.')[0] === '0000'
                        ? 'hidden'
                        : ''
                }`}
                onClick={() => {
                    exportRiskAssessment(
                        riskAssessmentData?.riskAssessmentId,
                        true
                    );
                }}
                key="lastPublic"
            >
                {t('RA.LatestVersion')}
            </Menu.Item>
            <Menu.Item
                className="p-4"
                onClick={() => {
                    exportRiskAssessment(
                        riskAssessmentData?.riskAssessmentId,
                        false
                    );
                }}
                key="lastEdit"
            >
                {t('RA.LatestModified')}
            </Menu.Item>
        </Menu>
    );

    // useEffect(() => {
    //     if (admin) {
    //         navigate(ROUTER.RISK_MANAGEMENT.RR);
    //     }
    // }, []);

    return (
        <div>
            <div className="title flex">
                <button
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(`${ROUTER.RISK_MANAGEMENT.RR}`);
                    }}
                >
                    <IconBack />
                </button>
                {t('Risk Register')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Risk Register')} /
                </span>
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('Risk Register List')} /{' '}
                </span>
                <span> {switchText()}</span>
            </div>
            <div className="bg-white rounded-xl p-4 flex items-center space-x-2 my-4 justify-between">
                <div className="flex justify-center items-center space-x-4">
                    <span className="text-purple font-semibold text-2xl">
                        {t('RA.OrganizationRiskReport')}
                    </span>
                    <span className="text-xs">
                        {t('Version')} :{' '}
                        {riskAssessmentData?.version || '0000.0'}
                    </span>
                </div>
                <div className={`${view && admin ? '' : 'hidden'}`}>
                    <div className="flex justify-center items-center space-x-4">
                        <Dropdown
                            trigger={['click']}
                            overlayStyle={{ width: '255px' }}
                            overlay={menu}
                            placement="bottomRight"
                            disabled={isAuditor}
                        >
                            <Button
                                icon={<DownloadOutlined />}
                                type="primary"
                                size="large"
                                ghost
                            >
                                {t('Export')}
                            </Button>
                        </Dropdown>
                        <Button
                            disabled={isAuditor}
                            className={`${
                                riskAssessmentData?.version.split('.')[1] ===
                                    undefined ||
                                riskAssessmentData?.version.split('.')[1] ===
                                    '0'
                                    ? 'hidden'
                                    : ''
                            }`}
                            onClick={() => {
                                setOpenConfirm(true);
                            }}
                            size="large"
                            type="primary"
                        >
                            {t('common.publish')}
                        </Button>
                    </div>
                </div>
            </div>
            <div className="bg-white rounded-xl p-4">
                <RiskAssessmentDetailView
                    getRiskAssessmentHeader={() => getRiskRegisterHeader()}
                />
            </div>
            <ModalConfirm
                open={openConfirm}
                handelOk={() => {
                    setOpenConfirm(false);
                    publicRiskAssessment(riskAssessmentData?.riskAssessmentId);
                }}
                handelClose={() => setOpenConfirm(false)}
                text={t('Do you want to confirm')}
            />
            <ModalSuccess
                open={openSuccess}
                handelClose={() => {
                    setOpenSuccess(false);
                }}
                handelOk={() => {
                    setOpenSuccess(false);
                }}
                text={t('Successfully submitted data')}
            />
            <ModalFail
                open={openFail}
                handelClose={() => {
                    setOpenFail(false);
                }}
                handelOk={() => {
                    setOpenFail(false);
                }}
                text={t('Failed to submit data')}
            />
        </div>
    );
};
